import SepoliaAcreBTC from "@acre-btc/contracts/deployments/sepolia/acreBTC.json";
import MainnetAcreBTC from "@acre-btc/contracts/deployments/mainnet/acreBTC.json";
import { EthersContractWrapper, } from "./contract";
import { Hex } from "../utils";
import { EthereumAddress } from "./address";
class EthereumAcreBTC
// @ts-expect-error TODO: Figure out why type generated by typechain does not
// satisfy the constraint `Contract`. Error: `Property '[internal]' is missing
// in type 'AcreBTC' but required in type 'BaseContract'`.
 extends EthersContractWrapper {
    #BASIS_POINT_SCALE = BigInt(1e4);
    #cache = { entryFeeBasisPoints: undefined, exitFeeBasisPoints: undefined };
    constructor(config, network) {
        let artifact;
        switch (network) {
            case "sepolia":
                artifact = SepoliaAcreBTC;
                break;
            case "mainnet":
                artifact = MainnetAcreBTC;
                break;
            default:
                throw new Error("Unsupported network");
        }
        super(config, artifact);
    }
    /**
     * @see {AcreBTC#getChainIdentifier}
     */
    getChainIdentifier() {
        return this.getAddress();
    }
    /**
     * @see {AcreBTC#totalAssets}
     */
    totalAssets() {
        return this.instance.totalAssets();
    }
    /**
     * @see {AcreBTC#balanceOf}
     */
    balanceOf(identifier) {
        return this.instance.balanceOf(`0x${identifier.identifierHex}`);
    }
    /**
     * @see {AcreBTC#assetsBalanceOf}
     */
    assetsBalanceOf(identifier) {
        return this.instance.assetsBalanceOf(`0x${identifier.identifierHex}`);
    }
    /**
     * @see {AcreBTC#calculateDepositFee}
     */
    async calculateDepositFee(amount) {
        const entryFeeBasisPoints = await this.#getEntryFeeBasisPoints();
        return this.#feeOnTotal(amount, entryFeeBasisPoints);
    }
    /**
     * @see {AcreBTC#calculateDepositFee}
     */
    async calculateWithdrawalFee(amount) {
        const exitFeeBasisPoints = await this.#getExitFeeBasisPoints();
        return this.#feeOnTotal(amount, exitFeeBasisPoints);
    }
    async #getEntryFeeBasisPoints() {
        if (this.#cache.entryFeeBasisPoints) {
            return this.#cache.entryFeeBasisPoints;
        }
        this.#cache.entryFeeBasisPoints = await this.instance.entryFeeBasisPoints();
        return this.#cache.entryFeeBasisPoints;
    }
    async #getExitFeeBasisPoints() {
        if (this.#cache.exitFeeBasisPoints) {
            return this.#cache.exitFeeBasisPoints;
        }
        this.#cache.exitFeeBasisPoints = await this.instance.exitFeeBasisPoints();
        return this.#cache.exitFeeBasisPoints;
    }
    /**
     * @see {AcreBTC#encodeApproveAndCallFunctionData}
     */
    encodeApproveAndCallFunctionData(spender, shares, extraData) {
        const data = this.instance.interface.encodeFunctionData("approveAndCall", [
            `0x${spender.identifierHex}`,
            shares,
            extraData.toPrefixedString(),
        ]);
        return Hex.from(data);
    }
    /**
     * @see {AcreBTC#previewRedeem}
     */
    previewRedeem(shares) {
        return this.instance.previewRedeem(shares);
    }
    /**
     * @see {AcreBTC#convertToShares}
     */
    convertToShares(amount) {
        return this.instance.convertToShares(amount);
    }
    /**
     * @see {AcreBTC#encodeRedeemFunctionData}
     */
    encodeRedeemFunctionData(shares, receiver, owner) {
        // Parsed here rather than by the caller: this is the layer that knows the
        // chain, and `EthereumAddress.from` rejects anything that is not a valid
        // Ethereum address.
        const receiverAddress = EthereumAddress.from(receiver);
        // The zero address is well-formed, so `EthereumAddress.from` accepts it,
        // and the vault does not reject it either. The shares are burned as part
        // of the redemption, so redeeming to it would destroy the position with no
        // way to recover it.
        if (/^0+$/.test(receiverAddress.identifierHex))
            throw new Error("Receiver cannot be the zero address");
        const data = this.instance.interface.encodeFunctionData("redeem", [
            shares,
            `0x${receiverAddress.identifierHex}`,
            `0x${owner.identifierHex}`,
        ]);
        return Hex.from(data);
    }
    /**
     * Calculates the fee when it's included in the amount.
     * One is added to the result if there is a remainder to match the acreBTC
     * contract calculations rounding.
     * @param amount Amount in tBTC
     * @param feeBasisPoints Fee basis points applied to calculate the fee.
     * @returns The fee part of an amount that already includes fees.
     */
    #feeOnTotal(amount, feeBasisPoints) {
        const result = (amount * feeBasisPoints) / (feeBasisPoints + this.#BASIS_POINT_SCALE);
        if ((amount * feeBasisPoints) % (feeBasisPoints + this.#BASIS_POINT_SCALE) >
            0) {
            return result + 1n;
        }
        return result;
    }
}
// eslint-disable-next-line import/prefer-default-export
export { EthereumAcreBTC };
//# sourceMappingURL=acrebtc.js.map